<template>
  <b-modal
    :title="this.isView ? 'Xem chức vụ' : this.isEdit ? 'Sửa chức vụ' : 'Thêm mới chức vụ'"
    @hidden="hideModal"
    centered
    no-close-on-backdrop
    ref="modalCapNhatChucVu"
    size="lg"
  >
    <div class="row" v-if="isView">
       <div class="col-7 d-flex">
         <span class="form-title">Tên chức vụ : </span>
         <span class="font-size-12 ml-2"> {{form.chucVu}}</span>
       </div>
      <div class="col-5 d-flex">
        <span class="form-title">Mã chức vụ : </span>
        <span class="font-size-12 ml-2"> {{form.maChucVu}}</span>
      </div>
      <div class="col-7 d-flex">
        <span class="form-title">Nhóm chức vụ : </span>
        <span class="font-size-12 ml-2"> {{nhomChucVu.tenNhom}}</span>
      </div>
      <div class="col-5 d-flex">
        <span class="form-title">Thứ tự : </span>
        <span class="font-size-12 ml-2"> {{form.thuTu}}</span>
      </div>
    </div>
    <validation-observer ref="observerChucVu" v-else>
      <b-form>
        <div class="row">
          <div class="col col-6">
            <validation-provider
              rules="required|maxlength:100"
              name="Tên chức vụ"
              v-slot="validationContext"
            >
              <b-form-group
                class="mb-4"
                id="chucVu-input-group"
                label="Tên chức vụ"
                label-class="required font-weight-bold"
                label-for="chucVu-input"
              >
                <b-form-input
                  :state="getValidationState(validationContext)"
                  aria-describedby="chucVu-live-feedback"
                  class="border-radius-4"
                  id="chucVu-input"
                  name="chucVu-input"
                  v-model="form.chucVu"
                ></b-form-input>
                <b-form-invalid-feedback id="chucVu-live-feedback"
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col col-6">
            <validation-provider
              rules="required|maxlength:50|code|hashcode"
              name="Mã chức vụ"
              v-slot="validationContext"
            >
              <b-form-group
                class="mb-4"
                id="maChucVu-input-group"
                label="Mã chức vụ"
                label-class="required font-weight-bold"
                label-for="maChucVu-input"
              >
                <b-form-input
                  :state="getValidationState(validationContext)"
                  aria-describedby="chucVu-live-feedback"
                  class="border-radius-4"
                  id="maChucVu-input"
                  name="maChucVu-input"
                  v-model="form.maChucVu"
                ></b-form-input>
                <b-form-invalid-feedback id="chucVu-live-feedback"
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col col-6">
            <validation-provider name="Nhóm chức vụ" v-slot="validationContext">
              <b-form-group
                class="mb-4"
                id="idNhomChucVu-input-group"
                label="Nhóm chức vụ"
                label-class=" font-weight-bold"
              >
                <v-select
                  :class="
                    selectClass(
                      validationContext.invalid && validationContext.validated
                    )
                  "
                  :options="danhSachNhomChucVu"
                  :reduce="(text) => text.id"
                  label="tenNhom"
                  v-model="form.iD_NhomChucVu"
                >
                </v-select>
                <b-form-invalid-feedback
                  :force-show="
                    validationContext.invalid && validationContext.validated
                  "
                >
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col col-6">
            <b-form-group
              class="mb-4"
              id="thuTu-input-group"
              label="Thứ tự"
              label-class="font-weight-bold"
              label-for="thuTu-input"
            >
              <b-form-input
                aria-describedby="thuTu-live-feedback"
                class="border-radius-4"
                id="thuTu-input"
                name="thuTu-input"
                type="number"
                v-model="form.thuTu"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
      </b-form>
    </validation-observer>
    <template v-slot:modal-footer>
      <div class="d-flex">
        <base-button
          v-if="!isView"
          button="Lưu"
          @click="onSubmit()"
          :disabled="isLoading"
          class="btn btn-main ml-2"
        >
          {{ isEdit ? "Cập nhật" : "Thêm mới" }}
        </base-button>
        <base-button
          button="Đóng"
          @click="hideModal()"
          class="btn btn-line"
        >
          {{ BO_QUA_BUTTON_LABEL }}
        </base-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { BO_QUA_BUTTON_LABEL, ROUTE_NAME } from "@/constants/constants";
import { showMsgError } from "@/utils/commonUtils";

// import { isEmpty } from "lodash";

export default {
  name: "modalCapNhatChucVu",
  props: {
    data: {
      type: Object,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      form: {
        chucVu: "",
        maChucVu: "",
        iD_NhomChucVu: null,
        thuTu: null,
      },
      isLoading: false,
      nhomChucVu: null,
    };
  },
  computed: {
    ...mapGetters({
      danhSachNhomChucVu: "nhomChucVu/danhSachNhomChucVu",
    }),
  },
  created() {
    this.layDanhSachNhomChucVu();
  },
  methods: {
    layDanhSachNhomChucVu() {
      this.$store.dispatch("nhomChucVu/layDanhSachNhomChucVu");
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    hideModal() {
      this.$refs["modalCapNhatChucVu"].hide();
    },
    resetForm() {
      this.form = {
        chucVu: "",
        iD_NhomChucVu: null,
        thuTu: null,
      };
    },
    async onSubmit() {
      const isValid = await this.$refs.observerChucVu.validate();
      let thuTu = parseInt(this.form.thuTu);
      thuTu = isNaN(thuTu) ? null : thuTu;
      const payload = {
        ...this.form,
        thuTu: thuTu,
      };
      if (isValid) {
        this.isLoading = true;
        if (this.isEdit) {
          await this.$store
            .dispatch("chucVu/suaChucVu", {
              data: payload,
              onSuccess: this.hideModal,
            })
            .then(() => {
              this.hideModal();
              this.$emit("refreshData");
              this.isLoading = false;
            })
            .catch((err) => {
              this.isLoading = false;
              if (err) showMsgError(err.data.message);
            });
        } else {
          await this.$store
            .dispatch("chucVu/themChucVu", {
              data: payload,
              onSuccess: this.hideModal,
            })
            .then(() => {
              this.hideModal();
              this.isLoading = false;
              this.$emit("refreshData");
            })
            .catch((err) => {
              this.isLoading = false;
              if (err) showMsgError(err.data.message);
            });
        }
      }
    },
    selectClass(valid) {
      return {
        "select-invalid": valid,
      };
    },
  },
  watch: {
    data: function () {
      if (this.isEdit || this.isView) {
        this.form = Object.assign(this.form, this.data);
        this.nhomChucVu = this.danhSachNhomChucVu.find((item) => item.id === this.form.iD_NhomChucVu )
      } else {
        this.resetForm();
      }
    },
  },
};
</script>
